import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';

defineBlock({
    type: 'spacer',
    colour: '#ffffff',
    tooltip: '',
    movable: false,
    deletable: false,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    name: 'SPACER',
                    instance: () => new Blockly.FieldLabel('\u00A0'.repeat(40)),
                },
            ],
        },
    ],
});
